// App screenshot showcase.
// Screenshots live in /public/screenshots (resized to 720px wide for the web).
const shots = [
  { src: '/screenshots/discover-stores.png', caption: 'Discover stores near you' },
  { src: '/screenshots/home-page.png', caption: 'Your local picks at a glance' },
  { src: '/screenshots/in-shop-items.png', caption: 'Browse the full shop' },
  { src: '/screenshots/shopping-cart-screen.png', caption: 'Order in a tap' },
  { src: '/screenshots/rewards-tab.png', caption: 'Earn rewards as you shop' },
  { src: '/screenshots/qr-code-screen.png', caption: 'Scan to redeem in store' },
]

const Screenshots = () => {
  return (
    <section id="screenshots" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            See Nearbies in Action
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A quick look at the app — from finding local stores to earning rewards
          </p>
        </div>

        {/* Centered phone screenshots */}
        <div className="flex flex-wrap gap-10 sm:gap-12 justify-center items-start">
          {shots.map((shot, index) => (
            <div key={index} className="w-48 sm:w-56">
              {/* Phone-style frame */}
              <div className="rounded-[2rem] border-[6px] border-gray-900 bg-gray-900 shadow-xl overflow-hidden">
                <img
                  src={shot.src}
                  alt={shot.caption}
                  loading="lazy"
                  className="w-full h-auto block bg-gray-100"
                />
              </div>
              <p className="text-center text-sm font-medium text-gray-600 mt-4">
                {shot.caption}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Screenshots
